import { createContext } from "react";

const ChemBioPendingContext = createContext();
const PendingTableCellContext = createContext();

export { ChemBioPendingContext, PendingTableCellContext };
